import { createFileRoute } from "@tanstack/react-router";
import { InvoiceEditor } from "@/app/features/invoice/InvoiceEditor";

export const Route = createFileRoute("/")({
  component: InvoiceEditor,
});
